import { ReactNode } from 'react'

import { Pagination } from '~/core/pagination'
import { EErrorCode } from '~/shared/middleware/error-handling'

export enum EGuildIncomeType {
  Live = 0, // 礼物收益
  Noble, // 贵族收益
  SuperFan, // 超粉收益
  Play, // 玩法收益
}
export interface GuildDataBlockDefinition {
  name: string
  description: string
}

export interface GuildDataBlock<Source> {
  title: string
  field: keyof Source
  render?: (data?: Source) => ReactNode
}

export type ListTableRow<T> = T & {
  id: number | string
}

export enum EGuildIncomeStatus {
  // eslint-disable-next-line no-magic-numbers
  Cancel = -2,
  UnDone = -1,
  Done = 1,
}

export type GuildIncomeDetailItem = {
  c_time: number
  revenue: number
  status: EGuildIncomeStatus
  title: string
  username: string
  user_id: number
}
export interface GuildIncomeDetailTableRow extends GuildIncomeDetailItem {
  id: number
}

// 主播工作台 -> 工会收益列表请求参数
export type GuildLiveIncomeListParams = {
  start_date: string
  end_date: string
  p: number
  type: EGuildIncomeType
}

export type GuildLiveIncomeList = Pagination<{
  data: GuildIncomeDetailTableRow[]
  total: number
}>

// 当主播未加入公会时，接口会 error
export type GuildIncomeErrorType = {
  status: number
  data: {
    code: EErrorCode
    info: string
  }
}
